import {useEffect, useState} from "react";
import {findPayoutTransactionsWithPagination} from "../api/eventGroupApiClient";

export const usePayoutTransactions = (payoutId, page, pageSize, reloadTrigger) => {
    const [payoutTransactions, setPayoutTransactions] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const payoutTransactionsWithPagination = findPayoutTransactionsWithPagination(payoutId, page, pageSize, abortController.signal);

        payoutTransactionsWithPagination
            .then(
                (data) => {
                    const payoutTransactions = data.payoutTransactions;
                    const pagination = data.pagination;

                    setPayoutTransactions(payoutTransactions)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [payoutId, page, pageSize, reloadTrigger]);

    return {payoutTransactions : payoutTransactions, pagination};
};